export const module = {
  info: {
    name: 'voip-lcr-menu',
    caption: 'voip lcr menu',
    viewGroup: 'general-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'LCR',
    icon: 'el-icon-s-grid',
    routeName: 'module->voip-lcr-menu->lcr-panel',
    /*children: [
      {
        caption: 'Create Entity',
        icon: 'el-icon-plus',
        routeName: 'module->voip-lcr->create'
      },
      {
        caption: 'List Entities',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-lcr->list->page',
        routeParams: { listPage: 1}
      }
    ]*/
  }
}

export default module
